// 封装创建mqtt客户端方法

import mqtt from 'mqtt';
import { message } from 'antd';
enum ConnectionStatus {
  Connect = 'connect',
  Reconnect = 'reconnect',
  Error = 'error',
  Message = 'message',
  Offline = 'offline',
  CLOSE = 'close',
}
interface ClientWill {
  topic: string;
  payload: any;
  QoS: number;
  retain: any;
}

interface MqttClientEvent {
  onConnect?: AnyFunc;
  onError?: (err: any) => any;
  onReconnect?: AnyFunc;
  onMessage?: (topic: string, message: any, packet: any) => any;
  onOffline?: AnyFunc;
  onClose?: AnyFunc;
}

interface MqttConifg {
  events: MqttClientEvent;
  subscribes: string | string[];
  clean: boolean;
  // 连接超时时长 收到 CONNACK(确认连接请求，服务端发送给客户端的第一个报文) 之前等待的时间
  connectTimeout?: number;
  // 认证信息
  clientId: string;
  // 遗嘱消息，一个可配置的对象值，当客户端非正常断开连接时，Broker 就会向遗嘱 Topic 里面发布一条消息
  will?: ClientWill;
  maxConnectNum?: number;
  username?: string;
  password?: string;
}

export default class MqttClient {
  url: string;
  config: MqttConifg;
  client: any;
  closeCount: number = 0;
  maxConnectNum: number;
  constructor(mqttUrl: string, config: MqttConifg) {
    this.url = mqttUrl;
    this.config = config;
    this.maxConnectNum = this.config.maxConnectNum ?? 0;
    this.connectMqtt();
    this.initMqttEvent();
  }

  connectMqtt() {
    const options = {
      clean: this.config.clean,
      connectTimeout: this.config.connectTimeout,
      clientId: this.config.clientId,
      will: this.config.will,
      username: this.config.username,
      password: this.config.password,
      reconnectPeriod: 5000,
      protocolVersion: 5, // 使用v5协议
    };
    this.client = mqtt.connect(this.url, options);
  }

  initMqttEvent() {
    const { onConnect, onError, onReconnect, onMessage, onOffline, onClose } =
      this.config.events;
    this.client.on(ConnectionStatus.Connect, (connack: any) => {
      onConnect && onConnect(this.client);
      this.initSubscribe();
    });

    this.client.on(ConnectionStatus.Error, (err: any) => {
      onError && onError(err);
    });

    this.client.on(ConnectionStatus.Reconnect, () => {
      onReconnect && onReconnect();
    });

    this.client.on(
      ConnectionStatus.Message,
      (topic: string, message: any, packet: any) => {
        onMessage && onMessage(topic, JSON.parse(message.toString()), packet);
      },
    );
    this.client.on(ConnectionStatus.Offline, () => {
      onOffline && onOffline();
    });
    this.client.on(ConnectionStatus.CLOSE, () => {
      onClose && onClose();
      // if (this.closeCount > this.maxConnectNum) {
      //   this.closeCount = 0;
      //   message.warning('mqtt重连次数过多，请刷新页面重试！', 0);
      //   return;
      // }
      // this.closeCount++;
      // return setTimeout(() => {
      //   this.connectMqtt();
      //   this.initMqttEvent();
      // }, 1000);
    });
  }

  initSubscribe() {
    const { subscribes } = this.config;
    this.client.subscribe(subscribes);
  }

  publish(topic: string, message: string | Buffer) {
    this.client.publish(topic, message, function (error: any) {
      if (error) {
        console.log(error);
      }
    });
  }

  subscribe(topic: string) {
    this.client.subscribe(
      topic,
      { qos: 0 },
      function (error: any, granted: any) {
        if (error) {
          console.log(error);
        } else {
          console.log(`${granted[0].topic} was subscribed`);
        }
      },
    );
  }

  unsubscribe(topic: string) {
    this.client.unsubscribe(topic, function (error: any) {
      if (error) {
        console.log(error);
      } else {
        console.log('Unsubscribed');
      }
    });
  }

  end() {
    this.client.end(true, () => {
      console.log('00000');
    });
  }
}
